export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "thrusterDownload.worker.df768c532460d7c1478e-thrusterDownload.worker.worker.js");
}
